import {
  Alert,
  Box,
  Button,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { formatDate } from "../utils/dateUtils";

export default function VodomerReadingForm({
  activeVodomer,
  onSubmit,
  today,
  zobrazitVyberTypu,
}) {
  const [newReading, setNewReading] = useState("");
  const [photoFile, setPhotoFile] = useState(null);
  const [availableDates, setAvailableDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTypOdectu, setSelectedTypOdectu] = useState("");
  const [inputError, setInputError] = useState("");
  const isStavZadany = activeVodomer?.jizZadano;

  const typyOdectu = [
    { value: "M", label: "Mimořádná fakturace" },
    { value: "K", label: "Kontrolní" },
  ];

  useEffect(() => {
    const generateDates = () => {
      const dates = [];

      // Poslední den minulého měsíce
      const dnes = new Date(today);
      const lastDayPrevMonth = new Date(dnes.getFullYear(), dnes.getMonth(), 0);

      // Vytvoření intervalu od posledního dne minulého měsíce až po dnešek
      const tempDate = new Date(lastDayPrevMonth);

      while (tempDate <= dnes) {
        const formatted = formatDate(tempDate);
        dates.push({ value: tempDate.toISOString(), label: formatted });

        tempDate.setDate(tempDate.getDate() + 1);
      }

      return dates;
    };

    const generatedDates = generateDates();
    setAvailableDates(generatedDates);
    if (generatedDates.length > 0) {
      setSelectedDate(generatedDates[generatedDates.length - 1].value); // defaultně dnešek
    }
  }, [today]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (newReading < activeVodomer?.lastStav) {
      setInputError("Nový stav musí být větší než poslední stav.");
      setNewReading("");
      return;
    }

    const payload = {
      cislovm: activeVodomer?.cisloVodomeru,
      stav: newReading,
      oprava: activeVodomer?.jizZadano ? 1 : 0,
      typOdectu: selectedTypOdectu ? selectedTypOdectu : "F",
      // foto: photoFile,
      datum: selectedDate,
    };

    setNewReading("");
    setInputError("");
    setPhotoFile(null);
    onSubmit(payload);
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{ display: "flex", flexDirection: "column", gap: 2, p: 2 }}
    >
      <Typography variant="h6">
        Zadat aktuální stav vodoměru č. {activeVodomer?.cisloVodomeru}
      </Typography>

      <Typography variant="subtitle1">
        Poslední stav: {activeVodomer?.lastStav}
      </Typography>
      {isStavZadany && (
        <Alert severity="info">
          Tento vodoměr již má zadaný stav. Pokud chcete opravit stav, zadejte
          nový.
        </Alert>
      )}

      {inputError && (
        <Alert severity="error" sx={{ mb: 1 }}>
          {inputError}
        </Alert>
      )}

      {/* Výběr data */}
      <TextField
        select
        label="Datum odečtu"
        value={selectedDate}
        onChange={(e) => setSelectedDate(e.target.value)}
        fullWidth
        sx={{ textAlign: "start" }}
      >
        {availableDates.map((date) => (
          <MenuItem key={date.value} value={date.value}>
            {date.label}
          </MenuItem>
        ))}
      </TextField>

      {zobrazitVyberTypu && (
        <TextField
          select
          label="Typ odečtu"
          value={selectedTypOdectu}
          onChange={(e) => setSelectedTypOdectu(e.target.value)}
          fullWidth
          required
          sx={{ textAlign: "start" }}
        >
          {typyOdectu.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </TextField>
      )}

      {/* Nový stav */}
      <TextField
        label="Nový stav"
        type="number"
        value={newReading}
        onChange={(e) => setNewReading(e.target.value)}
        required
        fullWidth
      />

      {/* Odeslat */}
      <Button type="submit" variant="contained">
        Odeslat
      </Button>
    </Box>
  );
}
